import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {UserSubscription, UserSubscriptionType} from "../../../../../../user/user-subscription";
import {PaymentInfoComponent} from "../../../../payment-info/payment-info.component";
import {ChosenPlan} from "../../../../payment-info/models/plan.model";
import {TextUtils} from "../../../../../utils/text-utils";
import {FormControl} from "@angular/forms";
import {DbValidators} from "../../../../../validators/DbValidators";
import {CouponCode} from "../../../../../../workspace/billing/coupon";
import {Config} from "../../../../../../config/config";
import {first} from "rxjs/operators";
import {CouponCodeMapper} from "../../../../../../workspace/billing/coupon-mapper";
import {AuthService} from "../../../../../../auth/auth.service";

export type PaidFeatureUpgradeMode =
  'ssh'
  | 'cloudflare'
  | 'regenerate'
  | 'pro-level'
  | 'passwordProtect'
  | 'professional';

@Component({
    selector: 'db-paid-feature-upgrade-checkout',
    templateUrl: './paid-feature-upgrade-checkout.component.html',
    styleUrls: ['./paid-feature-upgrade-checkout.component.scss'],
    standalone: false
})
export class PaidFeatureUpgradeCheckoutComponent implements OnInit {

  @ViewChild(PaymentInfoComponent) paymentInfo: PaymentInfoComponent;
  @Input() userSubscription: UserSubscription;
  @Input() mode: PaidFeatureUpgradeMode;
  @Input() chosenPlan: ChosenPlan;
  @Input() expirationDate: string;
  @Input() buyAdditionalWord?: boolean;
  @Input() couponCode: string;
  @Output() onClose = new EventEmitter<boolean>();
  @Output() onStepChange = new EventEmitter<'plans'>();

  public loading = false;
  public featureDesc: string;
  public couponSectionToggled = false;
  public couponCodeInput = new FormControl('', [DbValidators.trim]);
  public coupon: CouponCode;
  public couponLoading = false;
  public applyDemoCoupon: boolean = false;
  public payPalInvalidCoupons = Config.couponsList.slice(1);
  public isPaypal = false;
  public newPrice: number = 0;


  public readonly userSubscriptionType = UserSubscriptionType;

  constructor(
    private readonly _authService: AuthService
  ) {
  }

  ngOnInit() {
    switch (this.mode) {
      case 'professional':
        this.featureDesc = TextUtils.getText('text_professionalPlanLockedFeatureDesc');
        break;
      case 'ssh':
        this.featureDesc = TextUtils.getText('text_paidFeatureDialogSSH');
        break;
      case 'cloudflare':
        this.featureDesc = TextUtils.getText('text_paidFeatureDialogCloudflare');
        break;
      case 'passwordProtect':
        this.featureDesc = TextUtils.getText('text_paidFeatureDialogPassProtection');
        break;
    }

    if (this.couponCode && this.couponCode !== '1wf') {
      this.couponSectionToggled = true;
      this.couponCodeInput.setValue(this.couponCode);
    }
    this.applyCoupon(this.couponCode);

  }

  public handlePaymentIsPaypal(isPaypal: boolean) {
    this.isPaypal = isPaypal;
  }

  public applyCoupon(autoApply?): void {
    const coupon = autoApply ? autoApply : this.couponCodeInput.value;

    if (coupon && Config.couponsList.slice(1).includes(coupon)) {
      const coupon_type = "";
      this.couponLoading = true;
      this._authService.applyCoupon(this.chosenPlan.id, coupon, coupon_type)
        .pipe(
          first(response => !!response, null)
        )
        .subscribe(response => {
          this.couponLoading = false;
          if (!response.success) {
            this.deleteCoupon(false);
            this.couponCodeInput.setErrors({'invalidCode': true});
            return;
          }
          this.couponCode = coupon;
          this.couponCodeInput.setErrors(null);
          this.coupon = CouponCodeMapper.map(response.data);
          this.newPrice = response.data && response.data.new_price;
        });
    } else {
      this.deleteCoupon(false);
      this.couponCodeInput.setErrors({'invalidCode': true});
    }
  }

  public deleteCoupon(reset = true) {
    this.couponCodeInput.reset();
    if (reset) {
      this.newPrice = 0;
      this.coupon = null;
    }
  }

}
